<template>
  <d2-container>
    <h2>企业数据服务商管理</h2>
    <el-form ref="elForm" :model="formData" size="medium" label-width="100px">
      <el-row>
        <el-form-item label="服务商名称" prop="dd">
          <el-input v-model="listQuery.platformName" placeholder="服务商名称" clearable :style="{width: '763px'}"></el-input>
        </el-form-item>
      </el-row>
      <el-form-item size="large">
        <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>


    <!--表格-->
    <el-button size="small" class="filter-item"  style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">新增数据服务商</el-button>
    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">
      <el-table-column
              prop="devId"
              type="selection"
              width="55" label="序号">
      </el-table-column>
      <el-table-column
              prop="devId"
              label="服务商ID"
              width="100">
      </el-table-column>
      <el-table-column
              prop="appId"
              label="AppId"
              width="100">
      </el-table-column>
      <el-table-column
              prop="appKey"
              label="AppKey"
              width="300"
      >
      </el-table-column>
      <el-table-column
              prop="appSecret"
              label="AppSecret"
              width="300"
      >
        <template slot-scope="scope">
          <div class="hideBlock">{{scope.row.appSecret}}</div>
        </template>
      </el-table-column>
      <el-table-column
              prop="platformName"
              label="开发者企业名称" >
      </el-table-column>
      <el-table-column
              prop="devName"
              label="开发者名称"
      >
      </el-table-column>
      <el-table-column
              fixed="right"
              label="操作"
              width="120">
        <template slot-scope="scope">
          <el-button size="small" type="success" @click="handleUpdate(scope.row)">更新秘钥</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
      </div>
    </template>


    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form" label-width="140px">
        <el-form-item label="AppId">
          <el-input v-model="form.appId" placeholder="请输入一个AppId,例如:laoxutech"></el-input>
        </el-form-item>
        <el-form-item label="AppSecret">
          <el-input v-model="form.appSecret" placeholder="自定义秘钥，空则采用默认生成"></el-input>
        </el-form-item>
        <el-form-item label="开发者企业名称">
          <el-input v-model="form.platformName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="开发者名称">
          <el-input v-model="form.devName" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')"  size="small">取 消</el-button>
        <el-button v-if="dialogStatus=='create'"  size="small" type="primary" @click="create('form')">保存</el-button>
        <el-button v-if="dialogStatus=='update'" type="primary" size="small" @click="update('form')">更新</el-button>
      </div>
    </el-dialog>

  </d2-container>
</template>


<script>
    import {
        page,
        addObj,
        getObj,
        delObj,
        putObj
    } from '@/api/admin/sysDevApp/index';
    import { mapGetters } from 'vuex';
    export default {
        name: 'sysBaseMaterial',
        data() {
            return {
                dialogFormVisible:true,
                formData: {
                    platformName: undefined,
                },
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    materialName: null,
                },
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '创建'
                },
                tableKey: 0,
                form:{
                    appId:null,
                    platformName:null,
                    devName:null,
                    appSecret:null,
                },
                materialTypes:[
                    { value: '0', label: '附件上传' },
                    { value: '1', label: '表单录入' },
                    { value: '2', label: '附件或录入' },
                ]
            }
        },
        created() {
            this.getList();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        methods: {
            materialType(materialType){
                if(materialType==0){return "附件"}
                else if(materialType==1){return "录入"}
                else{return "附件或录入"}
            },
            getList() {
                this.listLoading = true;
                page(this.listQuery).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
            handleFilter() {
                this.getList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getList();
            },
            handleCreate() {
                this.resetTemp();
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
            },
            handleClick(row) {
                getObj(row.devId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'view';
                    });
            },handleUpdate(row) {
                getObj(row.devId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'update';
                    });
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.devId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },
            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        addObj(this.form)
                            .then((res) => {
                                if(res && res.code==400){
                                    this.$notify({
                                        title: '提示',
                                        message: res.message,
                                        type: 'warning',
                                        duration: 2000
                                    });
                                    return;
                                }
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.form.password = undefined;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetTemp() {
                this.form = {
                    devId:null,
                    materialName:null,
                    explainText:null,
                    materialType:null,
                    formType:null,
                    sort:null,
                };
            },
            resetForm(){
                this.listQuery={
                    page: 1,
                    limit: 20,
                    materialName: null,
                }
            }
        }
    }
</script>
<style scoped>
  .hideBlock{background-color:rgb(96 98 102);display:inline-block;width:240px;}
  .hideBlock:hover{background-color:rgb(250 250 250);}
</style>
